<div class="caption-bar">
  <div class="caption">
    {{ "home.welcome" | translate : { name: state.displayName } }}
  </div>
</div>
@if(state.modt){
<div class="stats" style="max-width: 550px; background-color: cornsilk">
  <div class="stats-caption">{{ "home.news" | translate }}</div>
  <div style="padding: 12px 17px">{{ state.modt }}</div>
</div>
}

<div class="stats">
  <div class="stats-caption">{{ "home.currentStatus" | translate }}</div>
  <ion-list>
    <ion-item (click)="routerService.routeToConstructionDayReportOverview()">
      <ion-label>{{ "home.openReports" | translate }}</ion-label>
      <ion-badge [color]="openReportsBadgeColor$ | async">{{
        openReports$ | async
      }}</ion-badge>
    </ion-item>

    <!--ion-item (click)="routerService.routeToTripReportOverview()">
      <ion-label>{{ 'home.openTrips' | translate }}</ion-label>
      <ion-badge [color]="openTripReportsBadgeColor$ | async">{{
        openTripReports$ | async
      }}</ion-badge>
    </ion-item-->

    <ion-item (click)="routerService.routeToAbsenceOverview()">
      <ion-label>{{ "home.openAbsences" | translate }}</ion-label>
      <ion-badge [color]="openAbsenceEntriesBadgeColor$ | async">{{
        openAbsenceEntries$ | async
      }}</ion-badge>
    </ion-item>

    <ion-item (click)="routerService.routeToMachinery()">
      <ion-label>{{ "home.openInspections" | translate }}</ion-label>
      <ion-badge [color]="openInspectionsBadgeColor$ | async">{{
        openInspections$ | async
      }}</ion-badge>
    </ion-item>
    @if(state.userHasMinType(1)){
    <ion-item (click)="routerService.routeToMachinery()">
      <ion-label>{{ "home.expiredInspections" | translate }}</ion-label>
      <ion-badge [color]="openMachinesBadgeColor$ | async">{{
        openMachines$ | async
      }}</ion-badge>
    </ion-item>
    <ion-item (click)="modalService.openMissingWorkEntriesModal()">
      <ion-label>{{ "home.missingHours" | translate }}</ion-label>
      <ion-badge [color]="missingWorkEntriesColor$ | async">{{
        missingWorkEntries$ | async
      }}</ion-badge>
    </ion-item>
    }
  </ion-list>
</div>
